var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Article } from './article';
import { Div } from './base';
import { mdxComponents } from './mdx-components';
import { TableOfContent } from './table-of-content';
export const MarkdownArticle = (props) => {
    const { slug, content: { Component, headings, editUrl }, } = props;
    const hasSideContent = ((headings && headings.length > 0) || editUrl) && slug !== '';
    return (React.createElement(Div, { css: hasSideContent
            ? {
                '@xl': {
                    display: 'flex',
                    flexDirection: 'row-reverse',
                },
            }
            : undefined },
        hasSideContent ? (React.createElement(TableOfContent, { headings: headings, editUrl: editUrl })) : null,
        React.createElement(Article, { center: props.center, css: hasSideContent
                ? {
                    '@xl': {
                        width: '75%',
                    },
                }
                : undefined },
            React.createElement(Component, { components: components }))));
};
const { code: Code } = mdxComponents;
const components = Object.assign(Object.assign({}, mdxComponents), { code: function CustomCode(_a) {
        var { live, static: staticValue = !live } = _a, props = __rest(_a, ["live", "static"]);
        return React.createElement(Code, Object.assign({ static: staticValue }, props));
    } });
//# sourceMappingURL=markdown-article.js.map